import {ApiFilters} from '../../../core/models/interfaces/api-filters.interface';
import {ApiNotificationResponseDto, NotificationLevel, NotificationType} from '@birco/rainmesh-api';

export const FEATURE_NAME = 'notificationState';

export interface NotificationState {
  entities: Record<string, ApiNotificationResponseDto>; // Cache for the actual objects
  error: any | null;
  isLoading: boolean;
  filter: NotificationFilter;
  pages: Record<number, string[]>; // Page number to ids on that page
  totalCount: number;
  unreadCount: number;
}

export interface NotificationFilter extends ApiFilters {
  level?: NotificationLevel;
  type?: NotificationType;
  readState?: 'all' | 'unread';
}

export const initialState: NotificationState = {
  entities: {},
  filter: {
    page: 0,
    pageSize: 8,
    readState: 'unread',
  },
  pages: {},
  totalCount: 0,
  unreadCount: 0,
  isLoading: false,
  error: null,
};
